import {
  createBackup,
  getSiteDetails,
  listSites,
  listSnapshots
} from "@/services/api/app/office/recovery/share-point/sharePoint";
import {defaultPagination} from "@/services/pagination";
import drive from './data-set/drive'
import list from './data-set/list'
import exports from "@/store/app/office/recovery/share-point/exports";
import restores from "@/store/app/office/recovery/share-point/restores";
import backups from "@/store/app/office/recovery/share-point/backups";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";

const defaultState = () => ({
  sites: [],
  siteMap: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  listRegions: {},
  listRegionsGcp: {}
});

export default {
  namespaced: true,

  actions: {
    listSites({commit, state},) {
      return listSites({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setSites', result)
          commit('setPagination', pagination)
        })
    },
    getSiteDetails({commit}, siteId) {
      return getSiteDetails(siteId)
        .then(site => {
          commit('setSite', site);
          return site;
        })
    },
    createBackup({commit}, siteId) {
      return createBackup(siteId);
    },
    listSnapshots({commit}, {siteId, date, dateTo}) {
      return listSnapshots({siteId, date, dateTo})
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
  },

  mutations: {
    setSites(state, sites) {
      state.sites = sites;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setSite(state, site) {
      state.siteMap = {
        ...state.siteMap,
        [site.siteId]: site
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getSiteById: (state) => (id) => {
      return state.siteMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState(),

  modules: {
    drive,
    list,
    exports,
    restores,
    backups,
  },

}
